export const createHTMLNode = (tagName, children = []) => {
    return {
        type: 'element',
        tagName,
        properties: {},
        children,
    };
};
export const createTextNode = (content) => {
    return {
        type: 'text',
        value: content,
    };
};
//# sourceMappingURL=hast-builders.js.map